import { render, staticRenderFns } from "./BudgetStaff.vue?vue&type=template&id=feb6e660&"
import script from "./BudgetStaff.vue?vue&type=script&lang=ts&"
export * from "./BudgetStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports